(function () {
  if (customElements.get('ce-product-pickup-availability') !== undefined) {
    return;
  }

  class ProductPickupAvailability extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        product: 'ce-product',
        toaster: 'ce-toaster',
      };

      this.handleProductVariantId = this.handleProductVariantId.bind(this);
    }

    get isLoading() {
      return this.getAttribute('is-loading') === 'true';
    }

    set isLoading(value) {
      this.setAttribute('is-loading', value);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    static get observedAttributes() {
      return ['is-loading', 'variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-loading':
          if (newValue !== null) {
            if (newValue === 'true') {
              const html = `
                <div class="motion-safe:animate-pulse">
                  <div class="bg-body-text/25 h-5 mb-2 rounded-other w-1/1"></div>
                  <div class="bg-body-text/25 h-4 mb-2 rounded-other w-1/2"></div>
                  <div class="bg-body-text/25 h-5 rounded-other w-2/3"></div>
                </div>
              `;

              this.innerHTML = html;
            } else {
              this.innerHTML = '';
            }
          }

          break;
        case 'variant-id':
          if (newValue !== null) {
            this.isLoading = true;
            this._fetchSection(newValue);
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        product: this.closest(this.selectors.product),
        toaster: document.querySelector(this.selectors.toaster),
      };

      this.elements.product.addEventListener('ce-product:variant-id', this.handleProductVariantId);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.product.removeEventListener('ce-product:variant-id', this.handleProductVariantId);
    }

    handleProductVariantId(event) {
      this.variantId = event.detail;
    }

    async _fetchSection(variantId) {
      try {
        const resource = `${Themu.routes.root}variants/${variantId}?section_id=pickup-availability`;

        const response = await fetch(resource);

        if (!response.ok) {
          throw Error;
        }

        const responseText = await response.text();

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const innerHTML = html.querySelector('#shopify-section-pickup-availability').innerHTML;

        this.isLoading = false;
        this.innerHTML = innerHTML;
      } catch (error) {
        this.elements.toaster.makeToast('danger', Themu.t.products.pickup_availability.error_message);
      }
    }
  }

  customElements.define('ce-product-pickup-availability', ProductPickupAvailability);
})();
